import Radium from 'radium';
import { transitionDuration, transitionFunction } from 'globals/styles';
import { checkIcon } from 'globals/assets';

const animateIn = Radium.keyframes({
  from: {
    opacity: 0,
    transform: 'translate3d(0, -20px, 0)',
  },
  to: {
    opacity: 1,
    transform: 'translate3d(0, 0, 0)',
  },
});

export default {
  message: {
    maxWidth: '280px',
    width: '280px',
  },
  satisfaction: {
    margin: '10px 0',
  },
  rating: {
    borderRadius: '3px',
  },
  ratingPrompt: {
    fontSize: '12px',
    fontWeight: 500,
    textAlign: 'center',
  },
  ratingOptionsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  ratingOptions: {
    marginTop: '10px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  ratingOption: {
    width: '50px',
    height: '50px',
    cursor: 'pointer',
    borderRadius: '50%',
    ':hover': {
      opacity: 0.8,
    },
    ':active': {
      opacity: 0.8,
    },
  },
  ratingLabels: {
    display: 'flex',
    marginTop: '10px',
    width: '100%',
  },
  ratingLabelLeft_wide: {
    textAlign: 'left',
    whiteSpace: 'nowrap',
    color: '#7b858d',
    fontWeight: 500,
    fontSize: '11px',
    margin: '0 10px',
    flex: '1 1 50%',
    overflow: 'hidden',
  },
  ratingLabelRight_wide: {
    textAlign: 'right',
    whiteSpace: 'nowrap',
    color: '#7b858d',
    fontWeight: 500,
    fontSize: '11px',
    margin: '0 10px',
    flex: '1 1 50%',
    overflow: 'hidden',
  },
  ratingLabelLeft_narrow: {
    textAlign: 'right',
    whiteSpace: 'nowrap',
    color: '#7b858d',
    fontWeight: 500,
    fontSize: '11px',
    margin: '0 10px',
    flex: '1 1 50%',
    overflow: 'hidden',
  },
  ratingLabelRight_narrow: {
    textAlign: 'left',
    whiteSpace: 'nowrap',
    color: '#7b858d',
    fontWeight: 500,
    fontSize: '11px',
    margin: '0 10px',
    flex: '1 1 50%',
    overflow: 'hidden',
  },
  form: {
    marginTop: '20px',
  },
  questions: {
    marginTop: '20px',
    animation: 'slide-in-top 300ms cubic-bezier(0.215, 0.610, 0.355, 1.000) forwards',
    animationName: animateIn,
  },
  question: {
    marginTop: '10px',
  },
  questionLabel: {
    display: 'block',
    fontSize: '12px',
    fontWeight: 500,
  },
  questionField: {
    display: 'block',
    marginTop: '5px',
    borderRadius: '3px',
    borderColor: '#e3e3e3',
    width: '100%',
    lineHeight: '1.4em',
    padding: '5px',
    resize: 'none',
    outline: 'none',
  },
  questionFieldHint: {
    fontSize: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  submitButton: {
    marginTop: '20px',
    height: '35px',
    fontSize: '13px',
    fontWeight: 500,
    backgroundColor: '#52aaff',
    color: '#fff',
    borderRadius: '3px',
    width: '100%',
    border: '0',
    transition: `all ${transitionDuration} ${transitionFunction}`,
    outline: 'none',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#3088dc',
    },
    ':active': {
      backgroundColor: '#3088dc',
    },
  },
  completed: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px 0',
  },
  completedIcon: {
    display: 'block',
    backgroundImage: `url('${checkIcon}')`,
    backgroundColor: '#4eb96f',
    backgroundSize: '28px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '7px',
    height: '42px',
    width: '42px',
    borderRadius: '50%',
  },
  completedText: {
    marginTop: '10px',
    fontSize: '13px',
    fontWeight: 500,
    textAlign: 'center',
  },
  completedEditButton: {
    marginTop: '10px',
    fontWeight: 500,
    cursor: 'pointer',
    ':hover': {
      color: '#1093c3',
    },
    ':active': {
      color: '#1093c3',
    },
  },
};
